`<template>
  <b-row class="match-height">
    <b-col lg="12">
      <b-card title="Edit Payment Request">
        <b-form
@keyup.enter.prevent=""
@submit.prevent="submitEditPaymentRequest"
>
          <!-- Navigation Buttons -->
          <b-col
cols="12"
class="d-flex justify-content-between"
>
            <b-button
type="button"
variant="primary"
class="mr-1"
@click="previous()"
>
              <feather-icon
icon="ArrowLeftIcon"
size="16"
class="align-middle"
/>
              Back
            </b-button>
            <b-button
              v-if="isVisiblePrint"
              type="button"
              variant="primary"
              class="mr-1 float-right"
              @click="print()"
            >
              <feather-icon
icon="PrinterIcon"
size="16"
class="align-middle"
/>
              Print
            </b-button>
          </b-col>

          <!-- Form Fields -->
          <b-col cols="12">
            <b-form-group
label="Number"
label-for="payment_request_number"
>
              <b-form-input
id="payment_request_number"
v-model="paymentRequestNumber"
placeholder="Number"
/>
            </b-form-group>

            <b-form-group
label="Project"
label-for="payment_request_project"
>
              <b-form-input
id="payment_request_project"
v-model="paymentRequestProject"
placeholder="Project"
/>
            </b-form-group>

            <b-form-group
label="Currencies *"
label-for="payment_request_currency_id"
>
              <v-select-new
v-model="chosenCurrency"
:options="currencies"
/>
            </b-form-group>

            <b-form-group
label="Suppliers"
label-for="payment_request_category"
>
              <v-select-new
v-model="chosenSupplier"
:options="suppliers"
required
/>
            </b-form-group>

            <b-form-group
label="Bank"
label-for="payment_request_bank"
>
              <b-form-input
id="payment_request_bank"
v-model="paymentRequestBank"
/>
            </b-form-group>

            <b-form-group
label="Bank Number"
label-for="payment_request_bank_number"
>
              <b-form-input
id="payment_request_bank_number"
v-model="paymentRequestBankNumber"
/>
            </b-form-group>

            <b-form-group
label="Bank Owner"
label-for="payment_request_bank_owner"
>
              <b-form-input
id="payment_request_bank_owner"
v-model="paymentRequestBankOwner"
/>
            </b-form-group>

            <b-form-group
label="Notes"
label-for="payment_request_notes"
>
              <b-form-input
id="payment_request_notes"
v-model="paymentRequestNotes"
placeholder="Notes"
/>
            </b-form-group>

            <b-form-group
              v-if="paymentRequestAssetCategory"
              label="Asset Category"
              label-for="payment_request_asset_category"
            >
              <b-form-input
                id="payment_request_asset_category"
                v-model="paymentRequestAssetCategory"
                placeholder="Asset Category"
              />
            </b-form-group>

            <!-- Detail Rows -->
            <b-row class="mb-2">
              <b-col
cols="2"
class="text-center font-weight-bold"
>
Division
</b-col>
              <b-col
cols="1"
class="text-center font-weight-bold"
>
Cost Center
</b-col>
              <b-col
cols="2"
class="text-center font-weight-bold"
>
Facture Number
</b-col>
              <b-col
cols="2"
class="text-center font-weight-bold"
>
Description
</b-col>
              <b-col
cols="2"
class="text-center font-weight-bold"
>
Due Date
</b-col>
              <b-col
cols="2"
class="text-center font-weight-bold"
>
Nominal
</b-col>
              <b-col
cols="1"
class="text-center font-weight-bold"
>
Action
</b-col>
            </b-row>

            <div>
              <b-row
v-for="(chosen, index) in chosens"
:key="chosen.payment_request_detail_id || index"
>
  <b-col
cols="2"
class="text-center"
>
    <b-form-input
      v-model="chosen.payment_request_detail_divisi"
      type="text"
      placeholder="Division"
    />
  </b-col>

  <b-col
cols="1"
class="text-center"
>
    <b-form-input
      v-model="chosen.payment_request_detail_cost_center"
      type="text"
      placeholder="Cost Center"
      readonly
    />
  </b-col>

  <b-col
cols="2"
class="text-center"
>
    <b-form-input
      v-model="chosen.payment_request_detail_facture_number"
      type="text"
      placeholder="Facture Number"
    />
  </b-col>

  <b-col
cols="2"
class="text-center"
>
    <b-form-input
      v-model="chosen.payment_request_detail_description"
      type="text"
      placeholder="Description"
    />
  </b-col>

  <!-- ✅ fixed date field -->
  <b-col
cols="2"
class="text-center"
>
    <b-form-input
      type="date"
      :value="formatDate(chosen.payment_request_detail_due_date)"
      placeholder="Due Date"
      @input="updateDueDate(chosen, $event)"
    />
  </b-col>

  <b-col
cols="2"
class="text-center"
>
    <b-form-input
      v-model="chosen.payment_request_detail_nominal"
      type="number"
      placeholder="Nominal"
    />
  </b-col>

  <b-col
cols="1"
class="text-center"
>
    <b-button
      size="sm"
      type="button"
      variant="danger"
      @click="removeRow(chosen.payment_request_detail_id)"
    >
      <feather-icon
icon="TrashIcon"
size="18"
/>
    </b-button>
  </b-col>

  <b-col cols="12">
<br></b-col>
</b-row>

              <b-row>
                <b-col cols="12">
                  <b-button
variant="primary"
block
@click="addItem"
>
                    Add
                  </b-button>
                </b-col>
              </b-row>
              </div>

          </b-col>

          <!-- Submit and Reset Buttons -->
          <b-col
cols="12"
class="text-right mt-3"
>
            <b-button
type="submit"
variant="primary"
class="mr-1"
:disabled="submitButtonDisabled"
>
              Submit
            </b-button>
          </b-col>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue"
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"
import axios from "axios"
import moment from "moment-timezone"
import Ripple from "vue-ripple-directive"

import { VueHorizontalTimeline } from "vue-horizontal-timeline"
import { ref } from "@vue/composition-api"
import apiEndpoints from '@/constants/apiEndpoints'

const VersionCheck = ""
const statusItems = []
const items = []
const chosenItem = ref()
const chosens = []
const documents = []
const paymentRequestType = ""
const paymentRequestNumber = ""
const paymentRequestIsConfirmed = ""
const paymentRequestIsConfirmedByFACoalManager = ""
const paymentRequestClass = ""
const paymentRequestProject = ""
const paymentRequestCostCenter = ""
const paymentRequestQtyRequested = 0
const paymentRequestStatus = ""
const paymentRequestNotes = ""
const paymentRequestSupplier = ""
const paymentRequestNeedFor = ""
const paymentRequestCurrency = ""
const paymentRequestCurrencySymbol = ""
const paymentRequestBank = ""
const paymentRequestAssetCategory = ""
const paymentRequestId = ""
const chosenBranch = ""
const branches = []
const suppliers = []
const currencies = []
const chosenCurrency = ""
const chosenSupplier = ""
const chosenClass = ""
const userBranchCode = ""
const classes = ["Urgent", "Normal"]
const isCenter = false
const isVisiblePrint = false
export default {
  components: {
    BDropdownItem,
    BDropdown,
    BListGroup,
    BListGroupItem,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    VueHorizontalTimeline,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      paymentRequestId,
      userBranchCode,
      chosenSupplier,
      chosenCurrency,
      currencies,
      suppliers,
      paymentRequestCurrency,
      paymentRequestCurrencySymbol,
      paymentRequestSupplier,
      paymentRequestNeedFor,
      paymentRequestBank,
      paymentRequestAssetCategory,
      documents,
      isCenter,
      paymentRequestIsConfirmedByFACoalManager,
      paymentRequestType,
      paymentRequestIsConfirmed,
      chosenBranch,
      branches,
      chosenClass,
      classes,
      statusItems,
      VersionCheck,
      items,
      chosenItem,
      chosens,
      paymentRequestNumber,
      paymentRequestClass,
      paymentRequestProject,
      paymentRequestCostCenter,
      paymentRequestQtyRequested,
      paymentRequestStatus,
      paymentRequestNotes,
      isVisiblePrint,
    }
  },
  mounted() {
    this.chosens = []
    this.getDetails()
    this.getCurrencies()
    this.getSuppliers()
    const userData = this.$cookies.get('userData')
    const userBranch = userData.branch
    this.userBranchCode = userBranch.branch_code
  },
  methods: {
    submitEditPaymentRequest() {
      this.submitButtonDisabled = true
      const userToken = this.$cookies.get("userToken")
const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${userToken}`,
}
      if (this.chosens.length < 1) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please put at least one detail",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        })
        return
      }
      const body = {
        payment_request_id: this.paymentRequestId,
        payment_request_project_name: this.paymentRequestProject,
        payment_request_currency_id: this.chosenCurrency,
        payment_request_supplier_id: this.chosenSupplier,
        payment_request_bank: this.paymentRequestBank,
        payment_request_bank_number: this.paymentRequestBankAccountNumber,
        payment_request_bank_owner: this.paymentRequestBankAccountOwner,
        payment_request_note: this.paymentRequestNote,
        payment_request_claimed_to: this.PaymentRequestClaimedTo,
        payment_request_details: JSON.stringify(this.chosens),
        time: moment(),
      }
      const url = `${process.env.VUE_APP_API_URL}${apiEndpoints.API_EDIT_PAYMENT_REQUEST}`

      axios
        .post(url, body, { headers })
        .then(response => {
          this.submitButtonDisabled = false
          if (response.data.success === true) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Edit Direct PR Success",
                icon: "CheckIcon",
                variant: "success",
              },
            })
            this.$router.replace({
              name: "direct-pr",
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Edit Direct PR Failed",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            })
          }
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Edit Direct PR Failed",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          })
        })
    },
    formatDate(dateString) {
    // Ensure input shows correct format
    if (!dateString) return ''
    if (dateString.includes('T')) return dateString.split('T')[0]
    // fallback if date is already ISO without T
    return dateString
  },
  updateDueDate(chosen, value) {
    chosen.payment_request_detail_due_date = value ? `${value}T00:00:00.000Z` : null
  },
  removeRow(id) {
    this.chosens = this.chosens.filter(c => c.payment_request_detail_id !== id)
  },
    addItem() {
      const generateId = () => {
    return Math.random().toString(36).substr(2, 9)
  }
      const temp = {
        payment_request_detail_divisi: "Coal/Batubara",
                payment_request_detail_facture_number: "",
                payment_request_detail_cost_center: this.userBranchCode,
                payment_request_detail_description: "",
                payment_request_detail_due_date: "",
                payment_request_detail_nominal: "",
                payment_request_detail_id: generateId,
              }
      this.chosens.push(temp)
    },
    getSuppliers() {
      const userToken = this.$cookies.get("userToken")
const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${userToken}`,
}
      axios
        .get(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_CONTACTS}`,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            let dataResp = []
            const itemsJoin = []
            dataResp = response.data.data
            dataResp.map(elem => {
              itemsJoin.push({
                label: `${elem.contact_name}`,
                value: elem.contact_id,
              })
            })
            this.suppliers = itemsJoin
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Get Currencies Failed",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            })
          }
        })
        .catch(e => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Get Currencies Failed",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          })
        })
    },
    getCurrencies() {
      const userToken = this.$cookies.get("userToken")
const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${userToken}`,
}
      axios
        .get(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_CURRENCIES}`,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            let dataResp = []
            const itemsJoin = []
            dataResp = response.data.data
            dataResp.map(elem => {
              itemsJoin.push({
                label: `${elem.currency_full_name} (${elem.currency_code})`,
                value: elem.currency_id,
              })
            })
            this.currencies = itemsJoin
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Get Currencies Failed",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            })
          }
        })
        .catch(e => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Get Currencies Failed",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          })
        })
    },
    numberFormat(value) {
    if (Number.isNaN(value)) return "0,00"
    return new Intl.NumberFormat('id-ID', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value)
  },
    downloadAttachment(document) {
      const userToken = this.$cookies.get("userToken")
const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${userToken}`,
}
      const FileName = document.payment_request_document_file_name
      const ObjectName = `${document.payment_request_document_number}${FileName}`
      const body = {
        ObjectName,
        FileName,
      }
      axios
        .post(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_DOWNLOAD_ASSET}`,
          body,
          { headers },
        )
        .then(response => {
          if (response.data.Status === 1) {
            window.open(response.data.Payload, "_blank")
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Download Attachment success",
                icon: "CheckIcon",
                variant: "success",
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Something went wrong",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            })
          }
        })
    },
    getDetails() {
      const userToken = this.$cookies.get("userToken")
const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${userToken}`,
}
      const decoded = JSON.parse(localStorage.getItem("paymentRequestDetails"))
      this.chosenCurrency = {
                label: `${decoded.currency.currency_full_name} (${decoded.currency.currency_code})`,
                value: decoded.currency.currency_id,
              }
      this.chosenSupplier = {
                label: `${decoded.supplier.contact_name}`,
                value: decoded.supplier.contact_id,
              }
      this.paymentRequestId = decoded.payment_request_id
      this.paymentRequestProject = decoded.payment_request_project_name
      this.paymentRequestNumber = decoded.payment_request_number
      this.paymentRequestCurrency = decoded.currency.currency_full_name
      this.paymentRequestCurrencySymbol = decoded.currency.currency_symbol
      this.paymentRequestSupplier = decoded.supplier.contact_name
      this.paymentRequestBank = decoded.payment_request_bank
      this.paymentRequestBankNumber = decoded.payment_request_bank_number
      this.paymentRequestBankOwner = decoded.payment_request_bank_owner
      this.paymentRequestNotes = decoded.payment_request_note
      let obj0 = null
      let obj1 = null
      let obj2 = null
      let obj3 = null
      let obj4 = null
      let obj5 = null
      let obj6 = null
      let obj7 = null
                    obj1 = {
                      title: "Created",
                      content: `Direct PR Has been Created By ${
                        decoded.creator.user_fullname
                      } at ${this.dateSimple(
                        decoded.payment_request_created_time,
                        "YYYY-MM-DD",
                      )}`,
                      stepCssClass: "has-step-green",
                      boxCssClass: "has-color-red",
                    }
                    obj0 = {
                      title: "Lab Manager",
                      content:
                        decoded.payment_request_confirmed_by_lab_manager !== null
                          ? `Direct PR Has been Accepted by ${
                              decoded.lab_manager.user_fullname
                            } at ${this.dateSimple(
                              decoded.payment_request_confirmed_by_lab_manager_time,
                              "YYYY-MM-DD",
                            )}`
                          : `Direct PR Has not been Accepted By Lab Manager`,
                      stepCssClass:
                        decoded.payment_request_confirmed_by_lab_manager !== null
                          ? "has-step-green"
                          : "has-step-red",
                    }
                    obj2 = {
                      title: "Regional Manager",
                      content:
                        decoded.payment_request_confirmed_by_area_manager !== null
                          ? `Direct PR Has been Accepted by ${
                              decoded.area_manager.user_fullname
                            } at ${this.dateSimple(
                              decoded.payment_request_confirmed_by_area_manager_time,
                              "YYYY-MM-DD",
                            )}`
                          : `Direct PR Has not been Accepted By Regional Cabang`,
                      stepCssClass:
                        decoded.payment_request_confirmed_by_area_manager !== null
                          ? "has-step-green"
                          : "has-step-red",
                    }
                    obj3 = {
                      title: "Division Head",
                      content:
                        decoded.payment_request_confirmed_by_division_head !== null
                          ? `Direct PR Has been Accepted by ${
                              decoded.division_head.user_fullname
                            } at ${this.dateSimple(
                              decoded
                                .payment_request_confirmed_by_division_head_time,
                              "YYYY-MM-DD",
                            )}`
                          : `Direct PR Has not been Accepted By Division Head`,
                      stepCssClass:
                        decoded.payment_request_confirmed_by_division_head !== null
                          ? "has-step-green"
                          : "has-step-red",
                    }
                    obj4 = {
                      title: "FA Coal Manager",
                      content:
                        decoded.payment_request_confirmed_by_fa_coal_manager !== null
                          ? `Direct PR Has been Accepted by ${
                              decoded.fa_coal_manager.user_fullname
                            } at ${this.dateSimple(
                              decoded
                                .payment_request_confirmed_by_fa_coal_manager_time,
                              "YYYY-MM-DD",
                            )}`
                          : `Direct PR Has not been Accepted By FA Coal Manager`,
                      stepCssClass:
                        decoded.payment_request_confirmed_by_fa_coal_manager !== null
                          ? "has-step-green"
                          : "has-step-red",
                    }

                    this.statusItems = []
                    this.statusItems.push(obj1)
                    this.statusItems.push(obj0)
                    this.statusItems.push(obj2)
                    this.statusItems.push(obj3)
                    this.statusItems.push(obj4)
                    if (decoded.payment_request_amount_total > 50000000) {
                    obj5 = {
                      title: "Operational Director",
                      content:
                        decoded.payment_request_confirmed_by_operational_director !== null
                          ? `Direct PR Has been Accepted by ${
                              decoded.division_head.user_fullname
                            } at ${this.dateSimple(
                              decoded
                                .payment_request_confirmed_by_operational_director_time,
                              "YYYY-MM-DD",
                            )}`
                          : `Direct PR Has not been Accepted By Operational Director`,
                      stepCssClass:
                        decoded.payment_request_confirmed_by_operational_director !== null
                          ? "has-step-green"
                          : "has-step-red",
                    }
                    obj6 = {
                      title: "Vice President",
                      content:
                        decoded.payment_request_confirmed_by_vice_president !== null
                          ? `Direct PR Has been Accepted by ${
                              decoded.vice_president.user_fullname
                            } at ${this.dateSimple(
                              decoded
                                .payment_request_confirmed_by_vice_president_time,
                              "YYYY-MM-DD",
                            )}`
                          : `Direct PR Has not been Accepted By FA Coal Manager`,
                      stepCssClass:
                        decoded.payment_request_confirmed_by_vice_president !== null
                          ? "has-step-green"
                          : "has-step-red",
                    }
                    obj7 = {
                      title: "President Director",
                      content:
                        decoded.payment_request_confirmed_by_president_director !== null
                          ? `Direct PR Has been Accepted by ${
                              decoded.president_director.user_fullname
                            } at ${this.dateSimple(
                              decoded
                                .payment_request_confirmed_by_president_director_time,
                              "YYYY-MM-DD",
                            )}`
                          : `Direct PR Has not been Accepted By President Director`,
                      stepCssClass:
                        decoded.payment_request_confirmed_by_president_director !== null
                          ? "has-step-green"
                          : "has-step-red",
                    }
                    this.statusItems.push(obj5)
                    this.statusItems.push(obj6)
                    this.statusItems.push(obj7)
                  }
            axios
              .get(
                `https://api-proc.geolims.com/transactions/payment_requests/details/${decoded.payment_request_id}`,
                { headers },
              )
              .then(response2 => {
                if (response2.data.success === true && response2.data.data) {
                  if (decoded.payment_request_is_finished === true) {
                    this.isVisiblePrint = true
                  }
                  this.chosens = response2.data.data
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "Get Data Failed",
                      icon: "AlertTriangleIcon",
                      variant: "danger",
                    },
                  })
                }
              })
          },
    getDocuments() {
      const userToken = this.$cookies.get("userToken")
const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${userToken}`,
}
      const id = localStorage.getItem("paymentRequestDetailsId")
      axios
        .get(
          `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_GET_PAYMENT_REQUESTS_DOCUMENTS}/${id}`,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            const itemsJoin = []
            response.data.data.map(elem => {
              itemsJoin.push(elem)
            })
            this.documents = itemsJoin
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Get Documents Failed",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            })
          }
        })
        .catch(e => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Get Documents Failed",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          })
        })
    },
    getBranches() {
      const userToken = this.$cookies.get("userToken")
const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${userToken}`,
}
      axios
        .get(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_BRANCHES}`,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            const itemsJoin = []
            response.data.data.map(elem => {
              itemsJoin.push({
                label: `${elem.branch_name} (${elem.branch_code})`,
                value: elem.branch_id,
              })
            })
            this.branches = itemsJoin
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Get Branches Failed",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            })
          }
        })
        .catch(e => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Get Branches Failed",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          })
        })
    },
    getItems() {
      const userToken = this.$cookies.get("userToken")
const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${userToken}`,
}
      axios
        .post(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_PR_PLAN}`,
          {},
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            const itemsJoin = []
            response.data.data.map(elem => {
              itemsJoin.push({
                label: elem.item.item_name,
                value: elem.payment_request_detail_id,
                qty: elem.payment_request_detail_item_qty_requested,
              })
            })
            this.items = itemsJoin
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Get Data Success",
                icon: "CheckIcon",
                variant: "success",
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Get Data Failed",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            })
          }
        })
        .catch(e => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Get Settings Failed",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          })
        })
    },
    getOptionLabel(option) {
      return (option && option.label) || ""
    },
    applyItem(val) {

    },
    getOptionKey(option) {
      return (option && option.value) || ""
    },
    inputSearch(search) {

    },
    dateFormat(value, format = "MM/DD/YYYY") {
      return moment.utc(value).tz('Asia/Jakarta').format(format)
    },
    previous() {
      this.$router.push({ name: "direct-pr" })
    },
    dateSimple(value, format = "YYYY-MM-DD") {
      let dateRet = ""
      if (value !== null) {
        dateRet = moment.utc(value).tz('Asia/Jakarta').format(format)
      } else {
        dateRet = null
      }
      return dateRet
    },
    print() {
      const userToken = this.$cookies.get("userToken")
const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${userToken}`,
}
      const decoded = JSON.parse(localStorage.getItem("paymentRequestDetails"))
      const id = decoded.payment_request_id
      axios
        .get(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_DOWNLOAD_PAYMENT_REQUEST}${id}`,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            const url = `${process.env.VUE_APP_API_URL}temp/${response.data.data}`
            window.open(url, "_blank")
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Download Data failed",
                icon: "CheckIcon",
                variant: "danger",
              },
            })
          }
        })
    },
    capitalizeWords(str) {
    // Split the string into words using spaces as the separator
    const words = str.split(' ')
    // Capitalize the first letter of each word and join them back together
    const capitalizedWords = words.map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1)
    })
    // Join the capitalized words into a single string with spaces
    return capitalizedWords.join(' ')
    },
  },
}
</script>
`
